export const Analytics = {
    payloadFactory: (action, name) => {
        return (value) => ({ action, name, value });
    }
};
